function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M58.47,27.884H53.483l-8.1-16.205a3.01,3.01,0,0,0-5.36,2.742l6.794,13.525H17.4L24.19,14.359a3.01,3.01,0,0,0-5.36-2.742l-8.1,16.205H5.741A3.219,3.219,0,0,0,2.5,31.062v1.932a3.219,3.219,0,0,0,3.241,3.241h.748l4.3,21A3.213,3.213,0,0,0,13.968,59.8h36.4a3.213,3.213,0,0,0,3.179-2.555l4.3-21h.748a3.219,3.219,0,0,0,3.241-3.241V31.062A3.4,3.4,0,0,0,58.47,27.884ZM23.068,52a2.075,2.075,0,0,1-2.057,2.057h-1.06A2.075,2.075,0,0,1,17.895,52V36.672a2.075,2.075,0,0,1,2.057-2.057h1.06a2.075,2.075,0,0,1,2.057,2.057Zm11.655,0a2.075,2.075,0,0,1-2.057,2.057h-1.06A2.075,2.075,0,0,1,29.55,52V36.672a2.075,2.075,0,0,1,2.057-2.057h1.06a2.075,2.075,0,0,1,2.057,2.057Zm11.655,0a2.075,2.075,0,0,1-2.057,2.057h-1.06A2.075,2.075,0,0,1,41.205,52V36.672a2.075,2.075,0,0,1,2.057-2.057h1.06a2.075,2.075,0,0,1,2.057,2.057Z",
  transform: "translate(-2.5 -9.989)",
  fill: "#fff"
});

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59.335,
    height: 49.806,
    viewBox: "0 0 59.335 49.806",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.1131aa41.svg";
export { ForwardRef as ReactComponent };